<div class="font-bold mb-3" i18n>You have selected "USIM Test Algorithm" authentication algorithm.</div>
<div class="font-bold mb-3" i18n>Please select the following algorithm options according to your AuC configuration.</div>
<div class="ml-6 pt-3 mb-3">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>RES size</span>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.xorOptions.resSize"
          inputId="networkAuthentication.xorOptions.resSize#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.xorOptions.resSize"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.xorOptions.resSize#1" i18n>32 bits</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.xorOptions.resSize"
          inputId="networkAuthentication.xorOptions.resSize#2"
          value="2"
          [(ngModel)]="profileValues.networkAuthentication.xorOptions.resSize"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.xorOptions.resSize#2" i18n>64 bits</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.xorOptions.resSize"
          inputId="networkAuthentication.xorOptions.resSize#3"
          value="3"
          [(ngModel)]="profileValues.networkAuthentication.xorOptions.resSize"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.xorOptions.resSize#3" i18n>128 bits</label>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>MAC-A and MAC-S size</span>
      </td>
      <td (mouseover)="showTip(C.TIP_XOR_PARAM_MAC_SIZE)" (mouseout)="clearDynamicToast()">
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.xorOptions.macSize"
          inputId="networkAuthentication.xorOptions.macSize#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.xorOptions.macSize"
        ></p-radioButton>
      </td>
      <td (mouseover)="showTip(C.TIP_XOR_PARAM_MAC_SIZE)" (mouseout)="clearDynamicToast()">
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.xorOptions.macSize#1" i18n>64 bits</label>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>CK and IK size</span>
      </td>
      <td (mouseover)="showTip(C.TIP_XOR_PARAM_CKIK_SIZE)" (mouseout)="clearDynamicToast()">
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.xorOptions.ckikSize"
          inputId="networkAuthentication.xorOptions.ckikSize#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.xorOptions.ckikSize"
        ></p-radioButton>
      </td>
      <td (mouseover)="showTip(C.TIP_XOR_PARAM_CKIK_SIZE)" (mouseout)="clearDynamicToast()">
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.xorOptions.ckikSize#1" i18n>128 bits</label>
      </td>
    </tr>
  </table>
</div>
<div class="font-bold mb-3 pt-3" i18n>
  Note that OP or OPc, rotation constants, XORing constants, SQL options, SQN Delta, and SQL Age Limit will be ignored for "USIM Test
  Algorithm".
</div>
<div class="font-bold mb-3" i18n>K is pre-defined as 000102030405060708090A0B0C0D0E0F according to Section 8.2 of 3GPP TS 34.108.</div>
